/**
 * TanStack Query mutations for authentication operations
 */

import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { getApiBaseUrl } from "../config/api";

export interface ChangePasswordParams {
  currentPassword: string;
  newPassword1: string;
  newPassword2: string;
}

export function useChangePassword(token: string | null, userId: string | null) {
  return useMutation({
    mutationFn: async (params: ChangePasswordParams) => {
      if (!token || !userId) throw new Error("Not authenticated");

      const response = await axios.post(
        `${getApiBaseUrl()}/api/auth/change_password`,
        {
          password: params.currentPassword,
          user_id: userId,
          new_password_1: params.newPassword1,
          new_password_2: params.newPassword2,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.status !== 200) {
        throw new Error(response.data.message || "Failed to change password");
      }

      return response.data;
    },
  });
}
